export default __webpack_public_path__ + "static/media/5-taught.7e52c650.png";